import { SelfServeNodeLevels } from "../types";
import { useSelectedNode } from "./useSelectedNode";
export var useCurrentNodeHasMoreLevels = function useCurrentNodeHasMoreLevels(level) {
  var _currentNode;
  var nodes = useSelectedNode();
  var currentNode = level ? nodes["level".concat(level, "Node")] : undefined;
  if (!level) {
    for (var _level = SelfServeNodeLevels.length - 1; _level >= 0; _level--) {
      currentNode = nodes["level".concat(_level, "Node")];
      if (currentNode) {
        break;
      }
    }
  }
  var hasMoreIssueLevels = ((_currentNode = currentNode) === null || _currentNode === void 0 ? void 0 : _currentNode.children) !== undefined && currentNode.children.length > 0;
  return {
    hasMoreIssueLevels: hasMoreIssueLevels
  };
};